import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SEPARATED_WIDGETS } from 'utils/constants/sportsbook/generic';
import { MATCH_TRACKER_AVAILABLE_SPORTS } from 'utils/constants/sportsbook/match-tracker-sports';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { EMatchStreamingTypes } from 'interfaces/match-streaming';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import {
  getIsMatchStreamingChannelsAvailable,
  getIsTheatreMode,
  getMatchStreamingGameData,
  getMatchStreamingLiveStreamInfo
} from 'store/selectors/match-streaming';
import { getStreamData } from 'store/selectors/sport-data';

export const useGetAvailableModes = (): EMatchStreamingTypes[] => {
  const {
    params: { game: gameId }
  } = useSbRouteMatch(SEPARATED_WIDGETS.SEPARATED_WIDGETS_ROUTE);

  const streamData = useSelector(getStreamData);
  const isTheatreMode = useSelector(getIsTheatreMode);
  const liveStreamInfo = useSelector(getMatchStreamingLiveStreamInfo);
  const { game, sport } = useSelector(getMatchStreamingGameData) || {};
  const isChannelsAvailable = useSelector(getIsMatchStreamingChannelsAvailable);

  const isEventHasMatchTracker = useMemo(
    () =>
      sport &&
      MATCH_TRACKER_AVAILABLE_SPORTS.includes(game?.sport_alias || sport),
    [sport, game?.sport_alias]
  );

  const isMatchStreamingHasVideo = useMemo(() => {
    return !!streamData?.[Number(game?.id || gameId)]?.[0];
  }, [gameId, streamData, game?.id]);

  return useMemo<EMatchStreamingTypes[]>(() => {
    const modes = [];

    if (gameId) {
      if (
        isMatchStreamingHasVideo ||
        liveStreamInfo?.hasLiveStream ||
        isChannelsAvailable
      ) {
        modes.push(EMatchStreamingTypes.VIDEO);
      }

      if (isEventHasMatchTracker) {
        modes.push(EMatchStreamingTypes.MATCH);
      }
    }

    if (SpringConfigs.MOCKED_DATA) {
      modes.push(EMatchStreamingTypes.MATCH);
    }

    return modes;
  }, [
    game?.id,
    isTheatreMode,
    isChannelsAvailable,
    isEventHasMatchTracker,
    isMatchStreamingHasVideo,
    liveStreamInfo?.hasLiveStream
  ]);
};
